
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-3.2 -3.2 26.7 26.7","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.694 16.631l-2.816 2.797a1.588 1.588 0 01-.497.36 2.059 2.059 0 01-.604.19c-.014 0-.056.004-.127.011-.07.008-.162.011-.275.011-.268 0-.702-.046-1.302-.138-.6-.091-1.334-.317-2.202-.678-.868-.36-1.853-.9-2.954-1.62-1.1-.72-2.272-1.71-3.514-2.966-.988-.975-1.807-1.907-2.456-2.797-.65-.89-1.172-1.713-1.567-2.468C.985 8.577.688 7.892.49 7.277A10.905 10.905 0 01.089 5.69c-.07-.445-.099-.795-.084-1.05a18.3 18.3 0 00.02-.423 2.06 2.06 0 01.191-.604c.1-.205.219-.37.36-.498L3.391.297A.932.932 0 014.07 0a.79.79 0 01.487.159c.14.106.26.237.36.392l2.265 4.3c.127.227.162.474.106.742a1.32 1.32 0 01-.36.678L5.89 7.31a.354.354 0 00-.075.138.525.525 0 00-.031.159c.056.297.183.635.38 1.017.17.339.431.752.784 1.24.353.487.854 1.048 1.503 1.684.636.65 1.2 1.154 1.694 1.514.494.36.907.625 1.239.795.331.17.586.272.762.307l.264.053a.47.47 0 00.138-.032.352.352 0 00.138-.074l1.207-1.229c.254-.226.55-.339.889-.339.24 0 .43.043.572.127l4.107 2.416c.297.183.473.416.54.699a.968.968 0 01-.297.847z"}})])
          )
        }
      }
    